<template lang="html">
    <div class="grid-container">
        <ag-grid-vue style="width: 100%; height: 40vh;"
            class="ag-theme-alpine"
            :gridOptions="gridOptions"
            :defaultColDef="defaultColDef"
            :rowData="[]"
            :getRowId="getRowId"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :enableCellChangeFlash="true"
        >
        </ag-grid-vue>
    </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import MatchCellRenderer from './matchCellRenderer.vue';

export default {
    name: 'AdminInspectionTable',
    props: ['show_not_matched', 'show_matched', 'tags', 'type'],
    components: {
        AgGridVue,
        MatchCellRenderer,
    },
    data() {
        return {
            gridOptions: {
                columnDefs: [],
                rowAnimation: true,
                pagination: true,
                paginationPageSize: 50,
                columnTypes: "columnTypes",
            },
            defaultColDef: {
                width: 200,
                editable: false,
                filter: false,
                sortable: true,
                floatingFilter: false,
                resizable: false,
                cellDataType: false,
                cellRenderer: (data) => {
                    return data.value ? data.value : '-';
                }
            },
            overlayLoadingTemplate: `<img style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%) scale(0.2)" src="${this.loadingIcon}" aria-label="loading">`
        }
    },
    beforeMount() {
        this.gridOptions.columnDefs = [
            {
                headerName: '3D Model',
                field: 'point',
                colId: 'match',
                pinned: 'left',
                maxWidth: 150,
                headerClass: 'text-center',
                cellRenderer: 'MatchCellRenderer',
                cellRendererParams: {
                    clicked: (tag) => {
                        this.$store.state.adminAppContainer.open3dViewerIfNot();
                        this.$store.commit('SET_ON_SELECTION_CHANGED_CALLBACK', (object, point) => {
                            tag.children = [object];
                            tag.point = point;
                            this.$store.commit('SET_ON_SELECTION_CHANGED_CALLBACK', null);
                        });
                    }
                }
            },
            // { headerName: '3D Model', field: 'point', colId: 'point', pinned: 'left', maxWidth: 100, sortable: false,
            //     cellRenderer: (params) => {
            //         let lno = params.data.lnoCode;
            //         let inspection = this.amisTags.find(t => t.lnoCode == lno);
                    
            //         if (params.value || !!inspection?.children?.length) {
            //             return `<i class="fas fa-check" style="color:green;width: 100%;text-align: center;"></i>`;
            //         } else {
            //             return `<i class="fas fa-times" style="color:red;width: 100%;text-align: center;"></i>`;
            //         }
            //     }
            // },
            { headerName: "Tag No.", field: 'lnoCode', colId: 'lnoCode', maxWidth: 100, pinned: 'left', 
                sortable: true,
                comparator: (valueA, valueB) => {
                    if (valueA == valueB) return 0;
                    return (parseInt(valueA) > parseInt(valueB)) ? 1 : -1;
                }
            },
            { headerName: 'Name', field: 'lno', colId: 'lno', sortable: true, filter: false, pinned: 'left' },
            { headerName: 'Cr', field: 'cr', colId: 'cr', maxWidth: 100,
                cellStyle: this.cellStyle,
            },
            { headerName: 'Rt', field: 'rt', colId: 'rt', maxWidth: 100,
                cellStyle: this.cellStyle,
            },
            { headerName: 'Rl', field: 'rl', colId: 'rl', maxWidth: 100,
                cellStyle: this.cellStyle,
            },
            { headerName: 'El', field: 'el', colId: 'el', maxWidth: 150, sortable: true,
                cellRenderer: this.dateMonthYearRenderer,
                cellStyle: this.cellStyle,
            },
            { headerName: 'Last Inspection Date', field: 'ispDate', colId: 'ispDate', sortable: true,
                cellRenderer: this.dateRenderer,
                cellStyle: this.cellStyle,
            },
            { headerName: 'Next Inspection Date', field: 'nIspDate', colId: 'nIspDate', sortable: true,
                cellRenderer: this.dateRenderer,
                cellStyle: this.cellStyle,
            },
            { headerName: 'General regulations', field: 'lawName', colId: 'lawName'},
            { headerName: 'Code 1', field: 'lawName1', colId: 'lawName1'},
            { headerName: 'Code 2', field: 'lawName2', colId: 'lawName2'},
            { headerName: 'Code 3', field: 'lawName3', colId: 'lawName3'},
            { headerName: 'Temperature 1', field: 'temperature1', colId: 'temperature1'},
            { headerName: 'Temperature 2', field: 'temperature2', colId: 'temperature2'},
            { headerName: 'Temperature 3', field: 'temperature3', colId: 'temperature3'},
            { headerName: 'Temperature 4', field: 'temperature4', colId: 'temperature4'},
            { headerName: "Temperature Unit", field: 'temperatureUnit', colId: 'temperatureUnit'},
            { headerName: 'Pressure 1', field: 'pressure1', colId: 'pressure1'},
            { headerName: 'Pressure 2', field: 'pressure2', colId: 'pressure2'},
            { headerName: 'Pressure 3', field: 'pressure3', colId: 'pressure3'},
            { headerName: 'Pressure 4', field: 'pressure4', colId: 'pressure4'},
            { headerName: "Pressure Unit", field: 'pressureUnit', colId: 'pressureUnit'},
            { headerName: "Category", field: 'ctgName', colId: 'ctgName'},
            { headerName: "CL No.", field: 'clName', colId: 'clName'},
            { headerName: "Corrosion Loop No.1", field: 'cLNo1', colId: 'cLNo1'},
            { headerName: "Corrosion Loop No.2", field: 'cLNo2', colId: 'cLNo2'},
            { headerName: "Date of production", field: 'makDate', colId: 'makDate'},
            { headerName: "Fluid Classification 1", field: 'fluidClassification1', colId: 'fluidClassification1'},
            { headerName: "Fluid Classification 2", field: 'fluidClassification2', colId: 'fluidClassification2'},
            { headerName: "Flow Class", field: 'flwClsName', colId: 'flwClsName'},
            { headerName: "Flow name", field: 'flwName', colId: 'flwName'},
            { headerName: "Form", field: 'stName', colId: 'stName'},
            { headerName: "From", field: 'macFrom', colId: 'macFrom'},
            { headerName: "Function", field: 'fncName', colId: 'fncName'},
            { headerName: "Importance", field: 'impName', colId: 'impName'},
            { headerName: "Manufacturer", field: 'mkrName', colId: 'mkrName'},
            { headerName: "To", field: 'macTo', colId: 'macTo'},
            { headerName: "Type", field: 'macType', colId: 'macType'},
            { headerName: "Utilization status", field: 'useCase', colId: 'useCase'},
            { headerName: "Base specification Url", field: 'baseStyleUrl', colId: 'baseStyleUrl'},
            { headerName: "Thickness history Url", field: 'thickUrl', colId: 'thickUrl' }
        ];
    },
    mounted() {
        this.updateColumnVisibility();
        this.gridOptions.api?.clientSideRowModel?.setRowData(this.filteredData ?? []);
    },
    methods: {
        getRowId(params) {
            return params.data.id;
        },
        cellStyle(params) {
            if (!params.data || this.type != 'updatedInspections') return;

            let columnField = params.colDef.field;
            let lno = params.data.lnoCode;
            let oldInspection = this.amisTags.find(t => t.lnoCode == lno);

            if (!oldInspection) return;

            if (params.data[columnField] != oldInspection[columnField]) {
                return {
                    backgroundColor: '#acf58d',
                    color: '#000',
                    fontWeight: 500,
                };
            }

            return;
        },
        getBrightness(color) {
            const r = parseInt(color.substr(1, 2), 16);
            const g = parseInt(color.substr(3, 2), 16);
            const b = parseInt(color.substr(5, 2), 16);
            return ((r * 299) + (g * 587) + (b * 114)) / 1000;
        },
        updateColumnVisibility() {
            if (!this.gridOptions?.columnApi?.columnModel) return;

            const columnApi = this.gridOptions.columnApi.columnModel;

            this.gridOptions.columnDefs.forEach(c => {
                let o = this.inspectionPropertiesWithCheck.find(f => f.name == c.headerName);

                if (c.headerName == 'Pick Tag' && this.type == 'newInspections') columnApi.setColumnVisible(c.colId, false);

                if (o) columnApi.setColumnVisible(c.colId, o.isChecked);
            });
        },
        dateRenderer(params) {
            if (!params.value) return '-';
            return this.getDayDate(params.value);
        },
        dateMonthYearRenderer(params) {
            if (!params.value) return '-';
            return this.getYearMonthDate(params.value);
        },
        getDayDate(d) {
            if (!d) return '';
            var date = new Date(d)
            return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + (date.getDate())).slice(-2)}`
        },
        getYearMonthDate(d) {
            if (!d) return '';

            // Year month date.            
            if (d.split('-').length == 2) return d;

            var date = new Date(d);

            return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}`
        },
    },
    computed: {
        filteredData() {
            if (this.show_matched && this.show_not_matched) return this.tags;
            if (!this.show_matched && !this.show_not_matched) return [];
            if (this.show_matched) return this.matchedTags;
            if (this.show_not_matched) return this.notMatchedTags;
            return [];
        },
        matchedTags() {
            return this.tags.filter(t => !!t.children?.length);
        },
        notMatchedTags() {
            return this.tags.filter(t => !t.children?.length);
        },
        inspectionPropertiesWithCheck: {
            get() {
                return this.$store.getters.GET_INSPECTION_PROPERTIES_WITH_CHECK
            },
            set(value) {
                this.$store.commit('SET_INSPECTION_PROPERTIES_WITH_CHECK', value);
            }
        },
        visibleColumns() {
            return this.inspectionPropertiesWithCheck.filter(f => f.isChecked);
        },
        amisTags() {
            return this.$store.getters['GET_AMIS_TAGS'];
        },
    },
    watch: {
        visibleColumns() {
            this.updateColumnVisibility();
        },
        filteredData() {
            this.gridOptions.api?.clientSideRowModel.setRowData(this.filteredData);
        },
    }
}
</script>
<style lang="css">
.grid-container .ag-theme-alpine {    --ag-row-hover-color: #ad50871a !important;
    --ag-row-hover-color: #ad50871a !important;
}

.grid-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
}

.grid-container input {
    height: auto;
    font-weight: 400;
    color: inherit !important;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
    --ag-range-selection-border-color: transparent !important;
}

.ag-ltr .ag-cell,
.ag-header-cell, .ag-header-group-cell {
    border-right: var(--ag-borders-critical) var(--ag-border-color) !important;
}

.ag-header-cell.text-center .ag-header-cell-label {
    display: flex;
    justify-content: center;
}
</style>